const CSS_CHUNK_FAILED = /Loading CSS chunk [\w.-]+ failed/i;
const JS_CHUNK_FAILED = /Loading chunk [\w.-]+ failed/i;

export function isJsChunkLoadError(err) {
  if (!err) return false;
  const message = err.message != null ? String(err.message) : String(err);
  if (err.code === "CSS_CHUNK_LOAD_FAILED" || CSS_CHUNK_FAILED.test(message)) {
    return false;
  }
  if (err.name === "ChunkLoadError") return true;
  return JS_CHUNK_FAILED.test(message);
}
